import { render, staticRenderFns } from "./SwiperSlide.vue?vue&type=template&id=5a555700&scoped=true"
import script from "./SwiperSlide.vue?vue&type=script&lang=ts"
export * from "./SwiperSlide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a555700",
  null
  
)

export default component.exports